import { useState, useEffect } from 'preact/hooks';
import useApp from '../context/AppContext';
import { useToaster } from '../context/ToasterContext';
import FormEvent from '../components/ui/FormEvent';
import useEvent from '../hooks/useEvent';

export default function FormEventMarker(_route) {
    const { animals, markers, events } = useApp();
    if (typeof markers == 'undefined' || markers === null) {
        return (
            <div class="text-center">
                <div class="spinner-border text-warning" role="status">
                    <span class="visually-hidden">Loading markers...</span>
                </div>
            </div>
        );
    }
    const addToast = useToaster();
    const [submitButtonDisabled, setSubmitButtonDisabled] = useState(false);
    const { getEventInfo, saveEvent } = useEvent();
    const [selectedMarkers, setSelectedMarkers] = useState([]);
    const [eventInfo, setEventInfo] = useState(getEventInfo(_route, animals, events));
    const selectedAnimals = eventInfo.selectedAnimals;
    eventInfo.isCreateEvent = typeof _route.id == "undefined" || _route.id == "";
    eventInfo.isUnique = _route.animal_id;

    /**
     * Si edition evenement (_route.id)
     * - afficher tous les marqueurs et cocher ceux selectionnés
     * Si fiche un seul animal (_route.animal_id) :
     * - afficher tous les marqueurs et cocher ceux selectionnés
     * Si plusieurs animaux :
     * - afficher tous les marqueurs non cochés
     */
    useEffect(() => {
        eventInfo.markers = eventInfo.event?.markers ? eventInfo.event.markers : [];
        if (_route.id && eventInfo.event && eventInfo.markers) {
            setSelectedMarkers(eventInfo.markers.split(','));
        }
        else if (_route.animal_id) {
            if (selectedAnimals[0]) {
                const _markers = [];
                selectedAnimals[0].markers.map((marker) => {
                    _markers.push(marker.id.toString());
                });
                setSelectedMarkers(_markers);
            }
        }
        window.scrollTo(0, 0);
    }, []);

    useEffect(() => {
        if (eventInfo.chkMarkers) setSelectedMarkers(eventInfo.chkMarkers);
    }, [eventInfo.chkMarkers]);

    function handleMarkersChange(e) {
        const { value, checked } = e.target;
        if (checked) {
            setSelectedMarkers([...selectedMarkers, value]);
        }
        else {
            setSelectedMarkers(selectedMarkers.filter((markerId) => markerId !== value));
        }
    }

    function handleSubmit(e) {
        e.preventDefault();
        e.returnValue = '';

        const markersApi = [];
        const fields = e.target;
        selectedMarkers.map(markerId => {
            markersApi.push('/api/markers/' + markerId)
        })
        const formAnimal = {
            markers: markersApi,
        }
        const formEvent = {
            markers: selectedMarkers.join(','),
            date: fields.date.value,
            notes: fields.notes.value,
            type: 2,
            markerDelete: fields.switchAddDel ? fields.switchAddDel.checked : false
        }

        setSubmitButtonDisabled(true);
        saveEvent(selectedAnimals, formEvent, formAnimal, _route, true).then((responses) => {
            let error = 0;
            setSubmitButtonDisabled(false);
            responses.map(response => {
                addToast(response.type, response.message);
                if (response.type != 'success') error++;
            })
            if (error == 0) history.go(-1);
        });
    }

    return (
        <FormEvent title="Marqueurs"
            onSubmit={handleSubmit}
            eventInfo={eventInfo}
            message=""
            submitButtonDisabled={submitButtonDisabled}
            setEventInfo={setEventInfo}>
            <div class="form-control mb-3">
                {
                    !_route.animal_id &&
                    <div class="add-remove">
                        Ajouter
                        <div class="form-check form-switch d-inline-block align-middle ms-2">
                            <input class="form-check-input" type="checkbox" role="switch" id="switchAddDel" />
                        </div>
                        Supprimer
                    </div>
                }
                {
                    markers.map((marker) => {
                        return (
                            <div key={marker.id} class="row align-items-start">
                                <span class="col-1 mb-2">
                                    <input type="checkbox" class="form-check-input" id={'chk' + marker.id} name="chkMarkers" value={marker.id} checked={selectedMarkers.includes(marker.id.toString())} onChange={handleMarkersChange} />
                                </span>
                                <label class="col" for={'chk' + marker.id}>{marker.name} ({marker.animals.length})</label>
                                <span class="col">
                                    <input type="hidden" id={'color_' + marker.id} name={'color_' + marker.id} value={marker.color} />
                                    <div id={marker.id} class="marker-shape big" style={{ backgroundColor: marker.color }} value={marker.color} />
                                </span>
                            </div>
                        )
                    })
                }
            </div>
        </FormEvent>
    );
}